import { CacheRepository } from './iCacheRepository';
import { CacheKeys } from './cacheKeys';

export class LocalStorageCache implements CacheRepository {
    public get<T>(key: CacheKeys): T {
        const data = window.localStorage.getItem(`cache_${key}`);

        if (typeof (data ?? void 0) === 'undefined') {
            return void 0;
        }

        return JSON.parse(data) as T;
    }

    public set<T>(key: CacheKeys, value: T): boolean {
        window.localStorage.setItem(`cache_${key}`, JSON.stringify(value));

        return true;
    }

    public delete(key: CacheKeys): boolean {
        window.localStorage.removeItem(`cache_${key}`);

        return true;
    }
}
